<template>
  <div class="public-header">
    <img src="~assets/img/common/back.png" class="back" @click="goBack">
    <div class="title">{{title}}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.public-header {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 88px;
  padding: 0 15px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #fff;
  .back {
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    height: 34px;
    width: 21px;
  }
  .title {
    color: #393939;
    font-size: 36px;
    text-align: center;
    line-height: 40px;
  }
}
</style>